// import function to register Swiper custom elements
import Swiper from 'swiper';
import { register } from 'swiper/element/bundle';
import 'swiper/css/bundle';

// register Swiper custom elements
register();

document.querySelectorAll<HTMLElement>('[slider="teaser"]').forEach($element => {

    const teasers = [...$element.querySelectorAll('.teaser') as any];

    const swiper = document.createElement('swiper-container') as HTMLElement & { swiper: Swiper; };
    swiper.setAttribute('slides-per-view', 'auto');

    media('(max-width: 767.98px)', {
        onMatch: function () {
            while (swiper.childNodes.length > 0)
                swiper.childNodes.forEach(_ => _.remove());

            teasers.forEach(teaser => {
                const slide = document.createElement('swiper-slide');
                slide.style.padding = '0 0.5rem';
                slide.style.maxWidth = '80vw';
                slide.appendChild(teaser);
                swiper.appendChild(slide);
            })
            $element.childNodes.forEach(_ => _.remove());
            $element.appendChild(swiper);
            swiper.swiper.update();
            swiper.style.overflow = 'visible';
            swiper.style.margin = '0 -0.5rem';
        },
        onUnmatch: function () {
            $element.childNodes.forEach(_ => _.remove());
            teasers.forEach(teaser => {
                $element.appendChild(teaser);
            });
        }
    });

});


document.querySelectorAll<HTMLElement>('[slider="brandessence"]').forEach($element => {
    const swiper = new Swiper($element, {
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 0,
        infinite: true,
        loop: true,
        //autoplay: {
        //    delay: 4000
        //},
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        //centeredSlides: true,
        navigation: {
            nextEl: $element.querySelector('.swiper-button-next'),
            prevEl: $element.querySelector('.swiper-button-prev'),
        },
        //navigation: {
        //    nextEl: that.nextElementSibling.querySelector('.swiper-button-next'),
        //    prevEl: that.nextElementSibling.querySelector('.swiper-button-prev'),
        //},
        //pagination: {
        //    //el: ".headerslider .swiper-pagination",
        //    el: $element.querySelector('.swiper-pagination'),
        //    clickable: true,
        //    //renderBullet: function (index, className) { return '<span class="' + className + '">0' + (index + 1) + "</span>"; }
        //},
        //preloadImages: true,
        //// Enable lazy loading
        //lazy: {
        //    loadPrevNext: true,
        //    loadPrevNextAmount: 1,
        //    checkInView: true
        //},
        on: {
            afterInit: function (el) {

                var currentSlide = el.el.querySelector(".swiper-slide-visible .brandessence-slide");
                currentSlide.classList.add('fin');
            },
            activeIndexChange: function (el) {


                var element = el.el.querySelector(".swiper-slide-visible .brandessence-slide");
                if (element.classList.contains('fin')) {
                    element.classList.remove('fin');
                }

                setTimeout(function () {
                    element.classList.add('fin');

                },
                    200);
                document.querySelector('.right-text .title').setAttribute('data-step', element.querySelector('.r-title').getAttribute("data-step"));
                document.querySelector('.right-text .title').innerHTML = element.querySelector('.r-title').innerHTML;
                document.querySelector('.right-text .text').innerHTML = element.querySelector('.r-text').innerHTML;
            },
        }
    })
});


document.querySelectorAll<HTMLElement>('[slider="benefit"]').forEach($element => {
    const swiper = new Swiper($element, {
        // Optional parameters
        //direction: 'vertical',
        //loop: true,

        slidesPerView: 'auto',

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },
    })
});


type MediaEvents = {
    onMatch(): void;
    onUnmatch(): void;
};
function media(mediaBreakpoint: string, events: MediaEvents) {
    var breakpoint = window.matchMedia(mediaBreakpoint);
    var match = false;
    var check = () => {
        if (breakpoint.matches === true) {
            if (!match) {
                events.onMatch();
                match = true;
            }
        } else if (breakpoint.matches === false) {
            if (match) {
                events.onUnmatch();
                match = false;
            }
        }
    };
    if (!breakpoint.addEventListener) breakpoint.addEventListener = (_: string, x: any) => breakpoint.addListener(x);
    breakpoint.addEventListener('change', check);
    check();
}